// extracted by mini-css-extract-plugin
export default {"pagination-container":"Pagination_pagination-container__nxB61","active":"Pagination_active__080sH"};